<template >
    <div class="msg">
        <img src="@/assets/error icon/expressions.png" alt="">
        {{ message }}
    </div>
</template>
<script>
export default {
    name: 'ErrorMsgComponent' ,
    props: ['message']
}
</script>
<style scoped>
    .msg {
        padding: 0.5rem;
        margin-bottom: 1rem;
        color: #F93827;
        border: 1.2px solid #F93827;
        border-radius: 5px;
    }
    .msg img {
        width: 40px;
        height: 40px;
        margin-left: 0.5rem;
    }
</style>